import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, inputCls, labelCls, rd, PAYMENT_METHODS } from "./posShared";

export default function PayModal({ invoice, onClose, onPaid }) {
  const [amount, setAmount] = useState(invoice.balance || 0);
  const [method, setMethod] = useState("efectivo");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    const amt = Number(amount) || 0;
    if (amt <= 0) return toast.error("Ingresa un monto válido");
    setSaving(true);
    try {
      const { data } = await api.post(`/pos/invoices/${invoice.id}/pay`, { amount: amt, payment_method: method });
      toast.success(data.status === "pagada" ? "Factura saldada" : "Pago registrado");
      onPaid && onPaid(data);
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al registrar el pago");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-[96] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-sm rounded-2xl">
        <div className="flex items-center justify-between px-5 py-3 border-b border-neutral-100">
          <span className="font-medium">Registrar pago · {invoice.number}</span>
          <button data-testid="pay-close" onClick={onClose} className="text-neutral-400 hover:text-espresso"><X size={20} /></button>
        </div>
        <div className="p-5 space-y-3">
          <div className="flex justify-between text-sm"><span className="text-neutral-500">Cliente</span><span>{invoice.customer_name}</span></div>
          <div className="flex justify-between text-sm"><span className="text-neutral-500">Balance pendiente</span><span className="font-medium text-rose">{rd(invoice.balance)}</span></div>
          <div><label className={labelCls}>Monto a cobrar</label><input data-testid="pay-amount" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className={inputCls} /></div>
          <div><label className={labelCls}>Método de pago</label>
            <select data-testid="pay-method" value={method} onChange={(e) => setMethod(e.target.value)} className={inputCls}>
              {PAYMENT_METHODS.filter((m) => m.key !== "credito").map((m) => <option key={m.key} value={m.key}>{m.label}</option>)}
            </select>
          </div>
          <button data-testid="pay-submit" onClick={submit} disabled={saving} className="w-full bg-espresso text-cream rounded-full py-3 text-xs uppercase tracking-[0.15em] hover:bg-rose transition disabled:opacity-60">
            {saving ? "Registrando..." : "Registrar pago"}
          </button>
        </div>
      </div>
    </div>
  );
}
